import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { RootErrorBoundary } from './components/RootErrorBoundary'
import './index.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <RootErrorBoundary>
        <App />
      </RootErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
)
